import { render, staticRenderFns } from "./promotion-modal.vue?vue&type=template&id=91a89c56"
import script from "./promotion-modal.vue?vue&type=script&lang=js"
export * from "./promotion-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports